"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutonumberFieldLogic = void 0;
var autonumber_fieldtype_1 = require("./autonumber.fieldtype");
Object.defineProperty(exports, "AutonumberFieldLogic", { enumerable: true, get: function () { return autonumber_fieldtype_1.AutonumberFieldLogic; } });
